export const PART_1_TITLE = 'Part 1: Prepare'
export const PART_2_TITLE = 'Part 2: Steps'
export const PART_3_TITLE = 'Part 3: Wrap-Up'
